module.exports = __webpack_public_path__ + "img/newLogo.abcd8478.jpeg";